import axiosCall from './interceptor';
import URL from '../helper';

export const getSsoConfigDetails = async () => {
    const url = `${URL.SSO_SERVICE_URL}configDetails`;
    const response = await axiosCall('get', url);
    return response.data;
}

export const patchEnableSSO = async (enableSSO) => {
    const url = `${URL.SSO_SERVICE_URL}connection?enableSSO=${enableSSO}`;
    const response = await axiosCall('patch', url);
    return response.data;
}

export const getSsoConnnectionDetails = async () => {
    const url = `${URL.SSO_SERVICE_URL}connection`;
    const response = await axiosCall('get', url);
    return response.data;
}

export const updateSsoConfig = async (method, payload) => {
    const url = `${URL.SSO_SERVICE_URL}connection`;
    const response = await axiosCall(method, url, payload);
    return response.data;
}

export const syncDirectory = async (payload) => {
    const url = `${URL.SSO_SERVICE_URL}directory`;
    const response = await axiosCall('post', url, payload);
    return response.data;
}

export const getDirectorySyncInfo = async (payload) => {
    const url = `${URL.SSO_SERVICE_URL}directory`;
    const response = await axiosCall('get', url);
    return response.data;
}

export const verifySso = async tenantName => {
  const url = `${URL.SSO_SERVICE_URL}verifySSO?name=${tenantName}`;
  const response = await axiosCall('get', url);
  return response.data;
};
